import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { logoutUser } from '../slices/authSlice';

// Hook para autenticación
export const useAuth = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const login = useCallback(
    (email, password, userType) => {
      return dispatch({ type: 'auth/loginUser', payload: { email, password, userType } });
    },
    [dispatch]
  );

  const logout = useCallback(() => dispatch(logoutUser()), [dispatch]);

  const clearError = useCallback(() => {
    dispatch({ type: 'auth/clearError' });
  }, [dispatch]);

  return {
    ...auth,
    login,
    logout,
    clearError,
  };
};
